var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dui-notification",class:_vm.type},[_vm._v("\n  "+_vm._s(_vm.message)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }